export default "__VITE_ASSET__IOoDE0wk__"